import { cn } from '@/lib/css-utils'
import { ChevronRightIcon } from 'lucide-react'

export function SalaryInteractionIndicator({
  show,
  hasCircleBorder = true,
}: {
  show: boolean
  hasCircleBorder?: boolean
}) {
  return (
    <ChevronRightIcon
      className={cn(
        'w-4 h-4 text-copy-accent rounded-full',

        {
          'border border-border-muted': hasCircleBorder,
          block: show,
          hidden: !show,
        },
      )}
    />
  )
}
